import { IonCard, IonIcon } from '@ionic/react'
import { chevronForward, helpCircle } from 'ionicons/icons'
import React, { useRef } from 'react'
import { useInfoBox } from './infoBox/useInfoBox'

interface Props {
	title: string
	subText: string
	accuracy?: { text: string; color: string }
	range?: string
	children: React.ReactNode
	clickHandler?: () => void
	className?: string
	chevron?: boolean
	showHelpIcon?: boolean
	helpIconText?: string
}

const LinkCard: React.FC<Props> = ({
	children,
	title,
	subText,
	clickHandler,
	className,
	chevron = true,
	showHelpIcon = false,
	helpIconText,
	accuracy,
	range,
}) => {
	const anchorElement = useRef<HTMLIonCardElement>(null)
	const { open, InfoBoxComponent } = useInfoBox<HTMLIonCardElement>()

	const handleInfoClick = () => {
		if (showHelpIcon && helpIconText) {
			open([
				{
					content: <div style={{ padding: 6 }}>{helpIconText}</div>,
					anchor: anchorElement,
				},
			])
		}
	}

	return (
		<>
			<IonCard
				ref={anchorElement}
				onClick={showHelpIcon ? handleInfoClick : clickHandler}
				className={`link-card border border-[#e5e5e5] dark:border-brand-primary-200-dark bg-white dark:bg-background-200-dark hover group ${className}`}
			>
				<div className='left'>
					<div className='left-column'>{children}</div>
					<div className='title'>
						<div className='elementName text-text-dark dark:text-white'>{title}</div>
						<div className='subtext text-text-grey-200 dark:text-text-grey-100'>{subText}</div>
						{accuracy && (
							<div style={{ color: accuracy.color }} className='subtext'>
								{accuracy.text}
							</div>
						)}
						{range && <div className='subtext'>{range}</div>}
					</div>
				</div>

				{chevron && (
					<IonIcon
						icon={chevronForward}
						className='pr-2 text-text-dark dark:text-white transition-transform group-hover:scale-[1.2] group-hover:transition-transform'
					/>
				)}
				{showHelpIcon && (
					<IonIcon
						className='pr-2 text-text-dark dark:text-white transition-transform group-hover:scale-[1.2] group-hover:transition-transform'
						icon={helpCircle}
					/>
				)}
			</IonCard>

			{InfoBoxComponent}
		</>
	)
}

export default LinkCard
